import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  gridContainer: {
    marginTop: 0,
    marginBottom: theme.spacing(0.25),
  },
  button: {
    width: '100%',
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
    borderRadius: theme.spacing(1),
  },
}))

export default styles
